import { action, computed, observable, values, makeObservable } from 'mobx';

import { IEventItem } from '@gem/call/CallStore/Events/Events.types';

class Events {
  @observable data = observable.map<number, IEventItem>();

  constructor() {
    makeObservable(this);
  }

  @computed
  get list(): readonly IEventItem[] {
    return values(this.data);
  }

  @action
  addEvent = (data: IEventItem): void => {
    let key = data.timestamp;
    if (this.data.has(key)) {
      key++;
    }
    this.data.set(key, data);
  };

  @action
  deleteEvent(key: number): void {
    this.data.delete(key);
  }

  dispose(): void {
    this.data.clear();
  }
}

export default Events;
